import React from "react";

const PriorityBar = ({ items }) => (
  <div className="abr-priority-bars">
    {items.map((row, idx) => {
      const kind = row.kind || "met";
      const cls = `abr-pri-row${kind === "gap" ? " is-gap" : ""}${kind === "gap-top" ? " is-gap-top" : ""}${row.note ? " has-note" : ""}`;
      return (
        <div className={cls} key={`${row.label}-${idx}`}>
          <div className="abr-pri-label">{row.label}</div>
          <div className="abr-pri-bar-wrap">
            <div className="abr-pri-bar" style={{ width: `${row.pct}%` }} />
          </div>
          <div className="abr-pri-pct">{row.pct}%</div>
          {row.note ? <div className="abr-pri-note">{row.note}</div> : null}
        </div>
      );
    })}
  </div>
);

export default PriorityBar;
